import { render, staticRenderFns } from "./_rightPancake1 copy 2.vue?vue&type=template&id=96362b5e&scoped=true&"
import script from "./_rightPancake1 copy 2.vue?vue&type=script&lang=js&"
export * from "./_rightPancake1 copy 2.vue?vue&type=script&lang=js&"
import style0 from "./_rightPancake1 copy 2.vue?vue&type=style&index=0&id=96362b5e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96362b5e",
  null
  
)

export default component.exports